import { render, staticRenderFns } from "./getScheme.vue?vue&type=template&id=45c215ee&scoped=true"
import script from "./getScheme.vue?vue&type=script&lang=js"
export * from "./getScheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c215ee",
  null
  
)

export default component.exports